<template>
  <label id="toggle-mode">
    <input v-model="night"
      class="toggle-checkbox"
      type="checkbox"
      @change="toggle">

    <div class="toggle-slot">
      <div class="sun-icon-wrapper">
        <i class="far fa-fw fa-sun"></i>
      </div>
      <div class="toggle-button"></div>
      <div class="moon-icon-wrapper">
        <i class="far fa-fw fa-moon"></i>
      </div>
    </div>
  </label>
</template>

<script>
export default {
  name: 'TheUIToggle',

  data() {
    return {
      night: true,
    };
  },

  methods: {
    toggle() {
      if (!this.night) {
        document.body.classList.add('light');
      } else {
        document.body.classList.remove('light');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  #toggle-mode {
    position: relative;
    top: 0.375rem;
    margin: 0 2rem 0 0;
    cursor: pointer;
  }

  .toggle-checkbox {
    position: absolute;
    height: 0;
    width: 0;
    opacity: 0;
    cursor: pointer;
  }

  .toggle-slot {
    position: relative;
    height: 1.5rem;
    width: 3.25rem;
    border: 2px solid #e4e7ec;
    border-radius: 2rem;
    background-color: white;
    transition: all 0.25s ease;

    &:hover {
      border-color: $grey;
    }
  }

  .toggle-checkbox:checked ~ .toggle-slot {
    background-color: #374151;
  }

  .toggle-button {
    position: absolute;
    height: 1rem;
    width: 1rem;
    border-radius: 50%;
    background-color: #ffeccf;
    box-shadow: inset 0px 0px 0px 2px #ffbb52;
    transform: translate(1.75rem, 0.125rem);
    transition: background-color 250ms, border-color 250ms, transform 500ms cubic-bezier(.26,2,.46,.71);
  }

  .toggle-checkbox:checked ~ .toggle-slot .toggle-button {
    background-color: #485367;
    box-shadow: inset 0px 0px 0px 2px white;
    transform: translate(0.25rem, 0.125rem);
  }

  .sun-icon-wrapper {
    position: absolute;
    height: 1.5rem;
    width: 1.5rem;
    opacity: 1;
    transform: translate(0.125rem, 0.125rem) rotate(15deg);
    transform-origin: 50% 50%;
    transition: opacity 150ms, transform 500ms cubic-bezier(.26,2,.46,.71);

    svg {
      position: absolute;
      height: 1.125rem;
      width: 1.125rem;
      color: #ffbb52;
    }
  }

  .toggle-checkbox:checked ~ .toggle-slot .sun-icon-wrapper {
    opacity: 0;
    transform: translate(1.75rem, 0.125rem) rotate(0deg);
  }

  .moon-icon-wrapper {
    position: absolute;
    height: 1.5rem;
    width: 1.5rem;
    opacity: 0;
    transform: translate(0.125rem, 0.125rem) rotate(0deg);
    transform-origin: 50% 50%;
    transition: opacity 150ms, transform 500ms cubic-bezier(.26,2.5,.46,.71);

    svg {
      position: absolute;
      height: 0.875rem;
      width: 0.875rem;
      color: white;
    }
  }

  .toggle-checkbox:checked ~ .toggle-slot .moon-icon-wrapper {
    opacity: 1;
    transform: translate(1.75rem, 0.125rem) rotate(-15deg);
  }
</style>
